import { Comment, AddComment, CommentsDisabled } from '@mui/icons-material';
import { Box, IconButton, styled } from '@mui/material';
import { useState } from 'react';

const ControlContainer = styled(Box)({
  backgroundColor: 'white',
  borderRadius: '4px',
});

export const AddCommentComponent = ({ onAddComment }) => (
  <ControlContainer id="map-edit-polygon-control">
    <IconButton
      title="Add comment"
      size="small"
      onClick={onAddComment}
      sx={{ '& .MuiSvgIcon-root': { fontSize: '20px', color: 'black' } }}
    >
      <AddComment />
    </IconButton>
  </ControlContainer>
);

export const CloseCommentsComponent = ({ onCloseComments }) => {
  const [commentsOpen, setCommentsOpen] = useState(false);

  const handleToggleComments = () => {
    setCommentsOpen(!commentsOpen);
    onCloseComments();
  };

  return (
    <ControlContainer id="map-close-comments-control" sx={{ marginTop: '8px' }}>
      <IconButton
        title="Toggle comments"
        size="small"
        onClick={handleToggleComments}
        sx={{ '& .MuiSvgIcon-root': { fontSize: '20px', color: 'black' } }}
      >
        {commentsOpen ? <Comment /> : <CommentsDisabled />}
      </IconButton>
    </ControlContainer>
  );
};
